import { render, staticRenderFns } from "./ContractorHeader.vue?vue&type=template&id=88d10fdc"
import script from "./ContractorHeader.vue?vue&type=script&lang=js"
export * from "./ContractorHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports